import React, { useState, useEffect } from 'react'
import Loader from '../Loader/Loader'
import { getGlobalOccasions, deleteGlobalOccasions } from '../../Web Apis/Apis'
import { message, Pagination } from 'antd'
import Avtar from '../../Images/no image.png'
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import CreateGlobal from './CreateGlobal'
import EditGlobal from './EditGlobal'

function GlobalOccassions() {
const [loading, setLoading] = useState(false)
const [occassions, setOccassions] = useState([])
const [selectedOccasion, setSelectedOccasion]= useState({})


const [showCreateModalOpen, setShowCreateModalOpen] = useState(false)
const [showUpdateModal, setShowUpdateModal] = useState(false)
const [showDeleteModal, setShowDeleteModal] = useState(false)

const [action, setAction]= useState(false)

const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the current items for the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentOccasion = occassions.slice(indexOfFirstItem, indexOfLastItem);

const handleCreateModalOpen = () => {
    setShowCreateModalOpen(true)
}

const handleDeleteModalOpen = (occasion) => {
    setSelectedOccasion(occasion)
    setShowDeleteModal(true)
}

const handleUpdateModalOpen = (occasion) => {
  setSelectedOccasion(occasion)
  setShowUpdateModal(true)
}

const fetchGlobalOccasions = async () => {
    try {
        setLoading(true)

        const response = await getGlobalOccasions()
        if(response?.data?.success){
          const reverData = response?.data?.data?.reverse()
            setOccassions(reverData)
        }
        
    } catch (error) {
        console.log("Error while fetch relation category", error.message)
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.clear();
        window.location.href = "/login"
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding")
      }
    } finally {
      setLoading(false)
    }
}

useEffect(()=> {
    fetchGlobalOccasions()
},[action])

const hanldeDelete = async () => {
     try {
        setLoading(true)
    
        const response = await deleteGlobalOccasions(selectedOccasion)
        if (response?.data?.success){
          message.success(response?.data?.message)
          setShowDeleteModal(false)
          setAction(!action)
        }
      } catch (error) {
        console.log("Error while deleting category", error.message)
        message.error(error?.response?.data?.message || "Error occured")
      } finally {
        setLoading(false)
      }
    }

  return (
    <div className='p-4'>
    <div className='flex justify-between'>
      <h3 className='text-3xl font-bold'>Global Occasion Management</h3>
      <div className='flex justify-end'>
        <button
          onClick={handleCreateModalOpen}
          className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
        >
          Create
        </button>
      </div>
    </div>
    <table className='min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black'>
      <thead>
        <tr>
          <th className="py-2 px-4 border-b text-center">S.No</th>
          <th className="py-2 px-4 border-b text-center">Occasion Name</th>
          <th className="py-2 px-4 border-b text-center">Occasion Type</th>
          <th className="py-2 px-4 border-b text-center">Occasion Image</th>
          <th className="py-2 px-4 border-b text-center">Occasion Date</th>
          <th className="py-2 px-4 border-b text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentOccasion?.length > 0 ? (
            currentOccasion?.map((occasion, index) => (
                <tr key={occasion.id}
                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                >
                    <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td className="py-2 px-4 border-b">{occasion.occasionsName}</td>
                    <td className="py-2 px-4 border-b">{occasion.type}</td>
                    <td className="py-2 px-4 border-b flex justify-center">
                        <img
                        src={occasion.imageUrl || Avtar }
                        alt="category"
                        className="w-32 h-28 object-cover border border-gray-700 rounded-full"
                        // style={{ height: "60px", width: "60px", borderRadius: "50%" }}
                        />
                    </td>
                    <td className="py-2 px-4 border-b">{occasion.occasionDate}</td>

                    <td className="py-2 px-4 border-b ">
                                      <div className="flex flex-row justify-center ">
                                        {/* <button
                                          onClick={() => handleViewModalOpen(category)}
                                          className="text-blue-500 hover:text-blue-700 flex items-center"
                                        >
                                          <AiOutlineEye className="mr-1 text-2xl" />
                                        </button> */}
                                         <button
                                           onClick={() => handleUpdateModalOpen(occasion)}
                                           className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                         >
                                           <AiFillEdit className="mr-1 text-2xl" />
                                        </button> 
                                        <button
                                          onClick={() => handleDeleteModalOpen(occasion)}
                                          className="text-red-500 hover:text-red-700 flex items-center"
                                        >
                                          <AiFillDelete className="mr-1 text-2xl" />
                                        </button>
                                      </div>
                                    </td>
                </tr>
            ))
        ) : (
            <tr>
            <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No global occassion data found</td>
          </tr>
        )}
        </tbody>
        </table>
        {loading && <Loader/>}


        <div className="mt-4 flex justify-end">
                <Pagination
                  current={currentPage}
                  total={occassions.length}
                  pageSize={itemsPerPage}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                />
              </div>

        {showCreateModalOpen && (
            <CreateGlobal
            showCreateModalOpen={showCreateModalOpen}
            setShowCreateModalOpen={setShowCreateModalOpen}
            action={action}
            setAction={setAction}
            />
        )}

        {showUpdateModal && (
          <EditGlobal
          showEditModalOpen={showUpdateModal}
          setShowEditModalOpen={setShowUpdateModal}
          action={action}
          setAction={setAction}
          selectedOccasion={selectedOccasion}
          />
        )}

        {showDeleteModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">Confirm Delete</h3>
            <p className="mb-4 text-start text-white">Are you sure you want to delete this occassion ? </p>
            <div className="flex justify-end gap-4">
              <button onClick={() => { setShowDeleteModal(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={hanldeDelete} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                Delete
              </button>
            </div>
          </div>
        </div>
      )
      }
        </div>
  )
}

export default GlobalOccassions